<script setup>
import {reactive, computed, watch } from "vue";

const emit = defineEmits([
  'update:modelValue'
])

const props = defineProps({
  errors: Object,
  modelValue: Object,
  errorsName: String
})

const address = reactive({
  email: props.modelValue ? props.modelValue.email : '',
  phone_number: props.modelValue ? props.modelValue.phone_number : '',
  firstname: props.modelValue ? props.modelValue.firstname : '',
  lastname: props.modelValue ? props.modelValue.lastname : '',
  street: props.modelValue ? props.modelValue.street : '',
  house_number: props.modelValue ? props.modelValue.house_number : '',
  postal_code: props.modelValue ? props.modelValue.postal_code : '',
  city: props.modelValue ? props.modelValue.city : '',
  province: props.modelValue ? props.modelValue.province : '',
  country: props.modelValue ? props.modelValue.country : '',
})

watch(address, (address) => {
  emit('update:modelValue', address)
})

</script>

<template>
  <span class="inline-block py-3 text-left text-lg font-medium text-gray-500">
    <slot name="title">
    Voer uw gegevens in
    </slot>
  </span>

  <div class="h-full -translate-y-6">

    <div class="mt-6">
      <label for="email" class="block text-sm font-medium text-gray-700">E-mailadres</label>
      <div class="mt-1">
        <input v-model="address.email" type="email" id="email" name="email" autocomplete="email" class="block w-full border-gray-300 rounded-md shadow-sm focus:ring-primary focus:border-primary sm:text-sm" />
        <div v-if="errors[errorsName + '.email']" v-text="errors[errorsName + '.email']" class="text-red-500 text-xs mt-1"></div>
      </div>
    </div>

    <div class="mt-6">
      <label for="phone_number" class="block text-sm font-medium text-gray-700">Telefoonnummer</label>
      <div class="mt-1">
        <input v-model="address.phone_number" type="tel" name="phone_number" id="phone_number" autocomplete="tel" class="block w-full border-gray-300 rounded-md shadow-sm focus:ring-primary focus:border-primary sm:text-sm" />
        <div v-if="errors[errorsName + '.phone_number']" v-text="errors[errorsName + '.phone_number']" class="text-red-500 text-xs mt-1"></div>
      </div>
    </div>
  </div>

  <span class="inline-block py-2 text-left text-lg font-medium text-gray-500">Adresgegevens</span>

  <div v-if="true" class="mt-2 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
    <div class="sm:col-span-3">
      <label for="first-name" class="block text-sm font-medium text-gray-700"> Voornaam </label>
      <div class="mt-1">
        <input v-model="address.firstname" type="text" name="first-name" id="first-name" autocomplete="given-name" class="block w-full border-gray-300 rounded-md shadow-sm focus:ring-primary focus:border-primary sm:text-sm" />
      </div>
      <div v-if="errors[errorsName +'.firstname']" v-text="errors[errorsName + '.firstname']" class="text-red-500 text-xs mt-1"></div>
    </div>

    <div class="sm:col-span-3">
      <label for="last-name" class="block text-sm font-medium text-gray-700"> Achternaam </label>
      <div class="mt-1">
        <input v-model="address.lastname" type="text" name="last-name" id="last-name" autocomplete="family-name" class="shadow-sm focus:ring-primary focus:border-primary block w-full sm:text-sm border-gray-300 rounded-md" />
      </div>
      <div v-if="errors[errorsName +'.lastname']" v-text="errors[errorsName +'.lastname']" class="text-red-500 text-xs mt-1"></div>
    </div>

    <div class="sm:col-span-4">
      <label for="address-line1" class="block text-sm font-medium text-gray-700"> Straatnaam </label>
      <div class="mt-1">
        <input v-model="address.street" type="text" name="address-line1" id="address-line1" autocomplete="address-line1" class="shadow-sm focus:ring-primary focus:border-primary block w-full sm:text-sm border-gray-300 rounded-md" />
      </div>
      <div v-if="errors[errorsName + '.street']" v-text="errors[errorsName + '.street']" class="text-red-500 text-xs mt-1"></div>
    </div>

    <div class="sm:col-span-2">
      <label for="address-line2" class="block text-sm font-medium text-gray-700"> Huisnummer </label>
      <div class="mt-1">
        <input v-model="address.house_number" type="text" name="address-line2" id="address-line2" autocomplete="address-line2" class="shadow-sm focus:ring-primary focus:border-primary block w-full sm:text-sm border-gray-300 rounded-md" />
      </div>
      <div v-if="errors[errorsName + '.house_number']" v-text="errors[errorsName + '.house_number']" class="text-red-500 text-xs mt-1"></div>
    </div>

    <div class="sm:col-span-2">
      <label for="postal-code" class="block text-sm font-medium text-gray-700"> Postcode </label>
      <div class="mt-1">
        <input v-model="address.postal_code" type="text" name="postal-code" id="postal-code" autocomplete="postal-code" class="shadow-sm focus:ring-primary focus:border-primary block w-full sm:text-sm border-gray-300 rounded-md" />
      </div>
      <div v-if="errors[errorsName + '.postal_code']" v-text="errors[errorsName + '.postal_code']" class="text-red-500 text-xs mt-1"></div>
    </div>

    <div class="sm:col-span-4">
      <label for="city" class="block text-sm font-medium text-gray-700"> Stad </label>
      <div class="mt-1">
        <input v-model="address.city" type="text" name="city" id="city" autocomplete="address-level2" class="shadow-sm focus:ring-primary focus:border-primary block w-full sm:text-sm border-gray-300 rounded-md" />
      </div>
      <div v-if="errors[errorsName + '.city']" v-text="errors[errorsName + '.city']" class="text-red-500 text-xs mt-1"></div>
    </div>

    <div class="sm:col-span-3">
      <label for="province" class="block text-sm font-medium text-gray-700"> Provincie </label>
      <div class="mt-1">
        <input v-model="address.province" type="text" name="city" id="city" autocomplete="address-level2" class="shadow-sm focus:ring-primary focus:border-primary block w-full sm:text-sm border-gray-300 rounded-md" />
      </div>
      <div v-if="errors[errorsName + '.province']" v-text="errors[errorsName + '.province']" class="text-red-500 text-xs mt-1"></div>
    </div>

    <div class="sm:col-span-3">
      <label for="country" class="block text-sm font-medium text-gray-700"> Land </label>
      <div class="mt-1">
        <select v-model="address.country" id="country" name="country" autocomplete="country-name" class="shadow-sm focus:ring-primary focus:border-primary block w-full sm:text-sm border-gray-300 rounded-md">
          <option value="NL" selected>Nederland</option>
        </select>
      </div>
      <div v-if="errors[errorsName + '.country']" v-text="errors[errorsName + '.country']" class="text-red-500 text-xs mt-1"></div>
    </div>
  </div>

</template>
